import shape1 from './shape1.svg';
import shape2 from './shape2.svg';
import shape3 from './shape3.svg';
import shape4 from './shape4.svg';
import shape5 from './shape5.svg';
import shape6 from './shape6.svg';

export default [shape1, shape2, shape3, shape4, shape5, shape6];